import { useMemo } from 'react';

import { useAvailablePageIds } from '../../ScreensContext';

const useNavigationWithExternalLinks = ({ navigation, externalLinks }) => {
  const ids = useAvailablePageIds();

  const isPageAvailable = (permission) => ids?.includes(permission);

  const mergeNavigationWithExternalLinks = (externalLinks, navigation) => {
    return externalLinks.reduce(
      (acc, { id, permission, title, link, children }) => {
        if (children) {
          return acc.map((item) => {
            const mergedChildren =
              item.title === title
                ? mergeNavigationWithExternalLinks(children, item.children)
                : null;

            const childrenSearchKey = mergedChildren
              ? children
                  .reduce((acc, { id }) => {
                    const mergedItem = mergedChildren.find(
                      (item) => item.id === id
                    );

                    if (!mergedItem) {
                      return acc;
                    }

                    const { searchKey } = mergedItem;

                    return [...acc, searchKey];
                  }, [])
                  .join('')
              : null;

            return mergedChildren
              ? {
                  ...item,
                  children: mergedChildren,
                  searchKey: `${item.searchKey}${childrenSearchKey}`,
                }
              : item;
          });
        }

        if (permission != null && !isPageAvailable(permission)) {
          return acc;
        }

        return [
          ...acc,
          {
            id,
            title,
            searchKey: title.toLowerCase(),
            externalLink: link,
            linkable: true,
          },
        ];
      },
      navigation
    );
  };

  return useMemo(() => {
    return externalLinks?.length
      ? mergeNavigationWithExternalLinks(externalLinks, navigation)
      : navigation;
  }, [externalLinks, navigation]);
};

export default useNavigationWithExternalLinks;
